/* eslint-disable max-len */
import React from 'react'
import TagBadge, {
  NOTE_TAG_OPTIONS,
} from '@components/common/TagBadge/TagBadge.component'

type NoteEditorNoteInfoProps = {
  tagDropdownRef: React.RefObject<HTMLDivElement>
  tagLockedToContext: boolean
  onTagClick: () => void
  effectiveTag: string
  showTagDropdown: boolean
  onTagSelect: (tagValue: string) => void
}

const NoteEditorNoteInfo = ({
  tagDropdownRef,
  tagLockedToContext,
  onTagClick,
  effectiveTag,
  showTagDropdown,
  onTagSelect,
}: NoteEditorNoteInfoProps): JSX.Element => (
  <div className="note-info-toolbar-overlay">
    <div className="note-info-content">
      <div className="note-info-tag" ref={tagDropdownRef}>
        Tagged as{' '}
        <span
          onClick={tagLockedToContext ? undefined : onTagClick}
          style={{
            cursor: tagLockedToContext ? 'default' : 'pointer',
            position: 'relative',
          }}
          title={
            tagLockedToContext
              ? 'Tag is fixed to current context (e.g. Charting)'
              : undefined
          }
        >
          <TagBadge tag={effectiveTag} />
        </span>
        {!tagLockedToContext && showTagDropdown && (
          <div className="tag-dropdown-menu tag-dropdown-menu--dropup">
            {NOTE_TAG_OPTIONS.map((tag) => (
              <div
                key={tag.value}
                className="tag-dropdown-item"
                onClick={() => onTagSelect(tag.value)}
              >
                <TagBadge tag={tag.value} />
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="note-info-dates">
        <div className="note-info-date">
          Created on {new Date().toLocaleDateString()}
        </div>
        <span>|</span>
        <div className="note-info-date">
          Last edited on {new Date().toLocaleDateString()}{' '}
          {new Date().toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          })}
        </div>
      </div>
    </div>
  </div>
)

export default NoteEditorNoteInfo
